<template>
  <div class="tenant-settings-list">
    <RouterLink to="/settings/custom-list">
      <setting-bar :count="null" title="Custom List">
      <template #icon-slot >
        <img class="btn-icon" src="~@/assets/images/icons/customlist-icon.svg" alt="" width="13px" />
      </template>
      </setting-bar>
    </RouterLink>
    <RouterLink to="/settings/copy-storage-locations">
      <setting-bar :count="null" title="Storage Locations">
      <template #icon-slot >
        <img class="btn-icon" src="~@/assets/images/icons/storage-location.svg" alt="" width="13px"/>
      </template>
      </setting-bar>
    </RouterLink>

    <RouterLink to="/settings/tags">
      <setting-bar :count="null" title="Tags">
      <template #icon-slot >
        <img class="btn-icon" src="~@/assets/images/icons/tags-icon.svg" alt="" width="13px"/>
      </template>
      </setting-bar>
    </RouterLink>
    <RouterLink to="/settings/tenant-calendar" v-if="!isOnProjectLevel">
      <setting-bar :count="null" title="Tenant Calendar">
      <template #icon-slot >
        <img class="btn-icon" src="~@/assets/images/icons/calendar-icon.svg" alt="" width="13px" />
      </template>
      </setting-bar>
    </RouterLink>
    <RouterLink to="/settings/project-calendar" v-if="isOnProjectLevel">
      <setting-bar :count="null" title="Calendar">
      <template #icon-slot >
        <img class="btn-icon" src="~@/assets/images/icons/calendar-icon.svg" alt="" width="13px"/>
      </template>
      </setting-bar>
    </RouterLink>

    <RouterLink to="/settings/copy-forms">
      <setting-bar :count="null" title="Forms">
      <template #icon-slot >
        <img class="btn-icon" src="~@/assets/images/icons/form-icon.svg" alt="" width="13px"/>
      </template>
      </setting-bar>
    </RouterLink>
    <RouterLink to="/settings/user-groups">
      <setting-bar :count="null" title="User Groups">
      <template #icon-slot >
        <img class="btn-icon" src="~@/assets/images/icons/user-group-icon.svg" alt="" width="13px"/>
      </template>
      </setting-bar>
    </RouterLink>
    <RouterLink to="/settings/copy-workflows/1">
      <setting-bar :count="null" title="Workflow">
      <template #icon-slot >
        <img class="btn-icon" src="~@/assets/images/icons/workflow-icon.svg" alt="" width="13px"/>
      </template>
      </setting-bar>
    </RouterLink>
    <RouterLink to="/settings/sequence-generator">
      <setting-bar :count="null" title="Sequence Generation">
      <template #icon-slot >
        <img class="btn-icon" src="~@/assets/images/icons/sequence-generator-icon.svg" alt="" width="13px"/>
      </template>
      </setting-bar>
    </RouterLink>
    <RouterLink to="/settings/config-feature">
      <setting-bar :count="null" title="Tenant Feature Configuration">
      <template #icon-slot >
        <img class="btn-icon" src="~@/assets/images/icons/tenant-feature-configuration.svg" alt="" width="13px"/>
      </template>
      </setting-bar>
    </RouterLink>
    <RouterLink to="/settings/checklist/list">
      <setting-bar :count="null" title="Checklist">
      <template #icon-slot >
        <img class="btn-icon" src="~@/assets/images/icons/check-list-icon.svg" alt="" width="13px" />
      </template>
      </setting-bar>
    </RouterLink>
  </div>
</template>

<script>
import { RouterLink } from 'vue-router'
import { mapGetters } from 'vuex'
import settingBar from '../common/settingsBar'
export default {
  name: 'TenantSettingsList',
  components: { RouterLink, settingBar },
  computed: {
    ...mapGetters(['isOnProjectLevel'])
  }
}
</script>

<style lang="scss" scoped>
.tenant-settings-list {
  width: 100%;
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  // background-color: var(--bg-color);
  border-right: 1px solid var(--borderColor);
  position: relative;
  a {
    text-decoration: none;
    color: var(--text-color);
  }
  &__header {
    position: sticky;
    top: 0;
    background-color: var(--brand-color);
  }
}
.tenant-settings-item {
  border: 1px solid var(--brand-color);
  background-color: var(--brand-color-3);
  margin: 6px 6px;
  padding-left: 6px;
  cursor: pointer;
  &__name {
    width: calc(100% - 30px);
    height: 30px;
  }
  .selected {
    background-color: var(--brand-color-2);
  }
  .obsolete {
    border-color: var(--alert);
    color: var(--alert);
  }
  & .toggle-button {
    height: 30px;
    width: 30px;
    background-color: var(--brand-color);
    cursor: not-allowed;
    pointer-events: none;
    opacity: 0.5;
    & img {
      height: 16px;
      width: 16px;
      transform: rotate(-90deg);
    }
  }
}
.router-link-active {
  .btn-icon {
    filter: invert(68%) sepia(85%) saturate(388%) hue-rotate(1deg) brightness(92%) contrast(88%);
  }
}
</style>
